// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1c5cp","right":"Footer_right__1bEBv","buttons":"Footer_buttons__1ER9s"};